const getMimeType = (type) => {
  switch (type) {
    case 'PDF':
      return 'application/pdf';
    case 'EXCEL':
      return 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'CSV':
      return 'text/csv, application/csv, .csv';
    case 'TEXT':
      return 'text/*';
    case 'APPLICATION':
      return 'application/*';

    default:
      return 'application/*';
  }
};

export const getAcceptedFileTypes = (acceptedTypes) => {
  switch (typeof (acceptedTypes)) {
    case 'string':
      return getMimeType(acceptedTypes.toUpperCase());
    case 'undefined':
      return '';
    default:
      if (Array.isArray(acceptedTypes)) {
        return [...(new Set(acceptedTypes.map(currentType => getMimeType(currentType.toUpperCase()))))].join(', ');
      } else {
        console.error('Expected acceptedTypes to be either a string or array. Received type: ', typeof (acceptedTypes));
      }
  }
};



// WEBPACK FOOTER //
// ./src/shared/helpers/fileHelper.js